import styled from "styled-components"
import { Color } from "../../styles/color"

const TableRow = styled.tr`
    background-color: ${Color.white};
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.05);
`

export default TableRow